<template>
  <div>
    <div class="shuffle-group container mx-auto">
      <div class="text-red-500 text-xl">
        LAUNCH — Start Mint on AUGUST 9, 13:00 UTC!
      </div>
      <h1 @click="shuffle">
        Couplepunks
      </h1>

      <div class="socialMedia">
        <a
          class="inline-block"
          href="https://opensea.io/collection/couplepunks"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M28.425 22.403c-.064-.064-.16-.064-.256-.032l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224.064-.032.032-.128-.032-.16zm-14.287-.705h3.652c.064 0 .096-.032.096-.096v-3.973c0-.032-.032-.064-.064-.096l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.096.032.16.096.16zM20 1.42C9.749 1.42 1.42 9.749 1.42 20c0 10.251 8.329 18.58 18.58 18.58 10.251 0 18.58-8.329 18.58-18.58C38.58 9.749 30.251 1.42 20 1.42zm-.064 32.099c-7.4 0-13.39-5.99-13.39-13.423 0-7.4 5.99-13.422 13.39-13.422s13.39 6.022 13.39 13.422c-.032 7.432-6.022 13.423-13.39 13.423zm8.233-11.148l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224 0-.064-.032-.16-.096-.192 0 0-.096-.032-.192 0zm-14.031-.673h3.652c.064 0 .096-.032.096-.096v-3.973c0-.032-.032-.064-.064-.096l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.096.032.16.096.16z"
              ></path>
              <path
                d="M17.822 17.565l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.064.032.128.096.128h3.652c.064 0 .096-.032.096-.096v-3.973a.069.069 0 00-.064-.064zm10.603 4.838c-.064-.064-.16-.064-.256-.032l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224.064-.032.032-.128-.032-.16z"
              ></path>
            </g></svg
        ></a>
        <a
          class="inline-block"
          href="
https://discord.com/invite/pdC9EAwj"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M32.878 8.185a30.645 30.645 0 00-7.564-2.346.115.115 0 00-.122.057 21.347 21.347 0 00-.941 1.935 28.292 28.292 0 00-8.496 0 19.579 19.579 0 00-.957-1.935.12.12 0 00-.121-.057 30.56 30.56 0 00-7.565 2.346.108.108 0 00-.05.043C2.246 15.426.926 22.446 1.573 29.38a.128.128 0 00.049.087c3.178 2.334 6.257 3.751 9.28 4.69a.12.12 0 00.13-.042 22.026 22.026 0 001.898-3.088.118.118 0 00-.064-.164 20.294 20.294 0 01-2.9-1.381.12.12 0 01-.011-.198c.195-.146.39-.298.576-.451a.115.115 0 01.12-.016c6.082 2.776 12.666 2.776 18.676 0a.114.114 0 01.122.014c.186.154.38.307.577.453a.12.12 0 01-.01.198c-.926.54-1.889.998-2.9 1.38a.119.119 0 00-.064.165 24.73 24.73 0 001.897 3.087c.03.04.082.059.13.044 3.037-.94 6.116-2.357 9.295-4.691a.12.12 0 00.048-.086c.775-8.016-1.298-14.979-5.494-21.152a.095.095 0 00-.049-.044zm-19.04 16.973c-1.832 0-3.34-1.68-3.34-3.745 0-2.065 1.479-3.746 3.34-3.746 1.874 0 3.368 1.696 3.339 3.746 0 2.064-1.48 3.745-3.34 3.745zm12.348 0c-1.831 0-3.34-1.68-3.34-3.745 0-2.065 1.48-3.746 3.34-3.746 1.875 0 3.369 1.696 3.34 3.746 0 2.064-1.465 3.745-3.34 3.745z"
              ></path>
            </g></svg
        ></a>
        <a
          class="inline-block"
          href="https://twitter.com/CouplePunks"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M38.526 8.625a15.199 15.199 0 01-4.373 1.198 7.625 7.625 0 003.348-4.211 15.25 15.25 0 01-4.835 1.847 7.6 7.6 0 00-5.557-2.404c-4.915 0-8.526 4.586-7.416 9.346-6.325-.317-11.934-3.347-15.69-7.953C2.01 9.869 2.97 14.345 6.358 16.612a7.58 7.58 0 01-3.446-.953c-.084 3.527 2.444 6.826 6.105 7.56a7.63 7.63 0 01-3.438.13 7.618 7.618 0 007.112 5.286A15.306 15.306 0 011.42 31.79a21.55 21.55 0 0011.67 3.42c14.134 0 22.12-11.937 21.637-22.643a15.499 15.499 0 003.799-3.941z"
              ></path>
            </g></svg
        ></a>
      </div>
      <Mint :msg="shuffle" />
      <!-- Using .shuffle-move class to work the transition -->
      <transition-group class="shuffle" name="shuffle">
        <div
          v-for="(item, index) in items"
          :key="item"
          :data-index="index"
          :class="'img inline-block ' + item.shape"
          v-bind:style="{
            backgroundImage: 'url(' + item.bg + ')',
          }"
        ></div>
      </transition-group>
    </div>
    <div class="story bg-black py-10">
      <div class="container mx-auto text-white text-left py-4 px-20">
        <h3 class="font-black text-3xl">About CouplePunks</h3>
        <p>
          We know it’s been difficult to mint an NFT before it’s sold out. So
          we’ve decided to launch 100,000 NFT CouplePunks. Everyone can get a
          CouplePunk!
        </p>
        <br/>
        <p>
          We’ve reserved 1000 CouplePunks airdrops for people who help support our project.
        </p>
        <br/>
        <p>
          It takes two punks to tango one of the 100,000 computer-generated
          CouplePunks. Some punk couples are rarer than others, such as Alien
          CouplePunks, Ape CouplePunks, and Zombie CouplePunks.
        </p>
        <br />
        <p>
          This project is inspired by<a
            class="text-blue-500"
            href="https://www.larvalabs.com/cryptopunks"
          >
            Larva Labs' CryptoPunks</a
          >
          and
          <a class="text-blue-500" href="https://www.covidpunks.com/"
            >COVIDPunk</a
          >.
        </p>
        <br />
        <h3 class="font-black text-3xl">CouplePunks Feature</h3>
        <p>
          <em> CouplePunks Status: </em>
        </p>
        <p>
          Each CouplePunk is minted with a random emotional status.
        </p>
        <br />
        <em>Emotional Status: </em>
        <p>
          CouplePunks that are <span style="color:#00c5ea">in love</span> will be facing each other, with a <span style="color:#00c5ea"> light
          blue </span> background and a <span style="color:#FF0000"> red </span>heart on top.
        </p>
        <br />
        <p>
          CouplePunks that are  <span style="color:#FF0000"> fighting </span> will be facing away from each other,
          with a <span style="color:#ffce47"> yellow </span>background and a <span style="color:#FF0000"> broken</span> heart.
        </p>
        <br />
        <p>
          One punk  <span style="color:#fe83b0"> is simping </span> another punk, will have two punks facing one
          direction, with a <span style="color:#fe83b0"> pink </span>background and a white heart on top.
        </p>
        <br />
        <p>
          One punk <span style="color:#008000"> is cheating </span> on another punk will be facing away from each other,
          with a <span style="color:#7f2ed8"> purple </span> background, and a <span style="color:#008000">green </span> heart on top.
        </p>
        <br />
        <p>
          CouplePunks that have <span style="color:#cfcfcf"> no feeling </span> towards one another will be facing
          each other, with a <span style="color:#55c089"> light green </span>background and  <span style="color:#cfcfcf"> white </span> heart on top.
        </p>
      </div>
    </div>
    <footer class="container mx-auto py-4">
      CouplePunks.Com
      <div class="socialMedia">
        <a
          class="inline-block"
          href="https://opensea.io/collection/couplepunks"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M28.425 22.403c-.064-.064-.16-.064-.256-.032l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224.064-.032.032-.128-.032-.16zm-14.287-.705h3.652c.064 0 .096-.032.096-.096v-3.973c0-.032-.032-.064-.064-.096l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.096.032.16.096.16zM20 1.42C9.749 1.42 1.42 9.749 1.42 20c0 10.251 8.329 18.58 18.58 18.58 10.251 0 18.58-8.329 18.58-18.58C38.58 9.749 30.251 1.42 20 1.42zm-.064 32.099c-7.4 0-13.39-5.99-13.39-13.423 0-7.4 5.99-13.422 13.39-13.422s13.39 6.022 13.39 13.422c-.032 7.432-6.022 13.423-13.39 13.423zm8.233-11.148l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224 0-.064-.032-.16-.096-.192 0 0-.096-.032-.192 0zm-14.031-.673h3.652c.064 0 .096-.032.096-.096v-3.973c0-.032-.032-.064-.064-.096l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.096.032.16.096.16z"
              ></path>
              <path
                d="M17.822 17.565l-1.794-.833c-.032-.032-.096 0-.128.065l-1.858 4.773c-.032.064.032.128.096.128h3.652c.064 0 .096-.032.096-.096v-3.973a.069.069 0 00-.064-.064zm10.603 4.838c-.064-.064-.16-.064-.256-.032l-.224.096c-1.09.544-2.307.8-3.524.8-.064 0-.096.033-.096.065-.128.576-.609.993-1.218.993H20.61v-2.083h.032c.16.032.288.032.448.064 1.057.16 1.57.641 1.794.865l.032.032a.097.097 0 00.128 0 .442.442 0 01.128-.096c.385-.256 1.282-.8 1.282-3.684 0-2.947-2.243-4.933-2.499-5.061l-1.313-.096h-.032v-.833a.943.943 0 00.448-.8c0-.513-.384-.93-.897-.93-.512 0-.897.417-.897.93 0 .32.16.608.449.768v.705l-1.89-.193c-.096 0-.16.097-.096.16.32.513 1.185 2.115 1.249 4.517.064 2.243-.288 3.3-.449 3.684-.032.032-.032.065 0 .097s.064.032.097.032c.224-.032.608-.097 1.089-.129v2.083h-2.083c-.672 0-1.249-.577-1.249-1.25v-.512c0-.064-.032-.096-.096-.096h-3.876c-.032 0-.096.032-.096.096v.288c0 1.442.416 2.755 1.12 3.908.13.193.353.289.546.193l.416-.193c.32-.16.705-.16 1.057 0l.449.193c.32.16.704.16 1.057 0l.448-.193c.353-.16.705-.16 1.057 0l.449.193c.352.16.705.16 1.057 0l.448-.193c.353-.16.705-.16 1.058 0l.448.193c.352.16.705.16 1.057 0l.449-.193c.352-.16.704-.16 1.057 0l.448.193c.289.128.609-.033.77-.32.255-.417.48-.898.64-1.346.352-1.057.993-2.05 1.986-2.531.096-.032.128-.128.128-.224.064-.032.032-.128-.032-.16z"
              ></path>
            </g></svg
        ></a>
        <a
          class="inline-block"
          href="
https://discord.com/invite/pdC9EAwj"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M32.878 8.185a30.645 30.645 0 00-7.564-2.346.115.115 0 00-.122.057 21.347 21.347 0 00-.941 1.935 28.292 28.292 0 00-8.496 0 19.579 19.579 0 00-.957-1.935.12.12 0 00-.121-.057 30.56 30.56 0 00-7.565 2.346.108.108 0 00-.05.043C2.246 15.426.926 22.446 1.573 29.38a.128.128 0 00.049.087c3.178 2.334 6.257 3.751 9.28 4.69a.12.12 0 00.13-.042 22.026 22.026 0 001.898-3.088.118.118 0 00-.064-.164 20.294 20.294 0 01-2.9-1.381.12.12 0 01-.011-.198c.195-.146.39-.298.576-.451a.115.115 0 01.12-.016c6.082 2.776 12.666 2.776 18.676 0a.114.114 0 01.122.014c.186.154.38.307.577.453a.12.12 0 01-.01.198c-.926.54-1.889.998-2.9 1.38a.119.119 0 00-.064.165 24.73 24.73 0 001.897 3.087c.03.04.082.059.13.044 3.037-.94 6.116-2.357 9.295-4.691a.12.12 0 00.048-.086c.775-8.016-1.298-14.979-5.494-21.152a.095.095 0 00-.049-.044zm-19.04 16.973c-1.832 0-3.34-1.68-3.34-3.745 0-2.065 1.479-3.746 3.34-3.746 1.874 0 3.368 1.696 3.339 3.746 0 2.064-1.48 3.745-3.34 3.745zm12.348 0c-1.831 0-3.34-1.68-3.34-3.745 0-2.065 1.48-3.746 3.34-3.746 1.875 0 3.369 1.696 3.34 3.746 0 2.064-1.465 3.745-3.34 3.745z"
              ></path>
            </g></svg
        ></a>
        <a
          class="inline-block"
          href="https://twitter.com/CouplePunks"
          target="_blank"
          rel="noopener noreferrer"
          ><svg
            class="h-8 w-8 m-2 fill-current text-black duration-150 hover:text-red-600"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill-rule="nonzero">
              <path
                d="M38.526 8.625a15.199 15.199 0 01-4.373 1.198 7.625 7.625 0 003.348-4.211 15.25 15.25 0 01-4.835 1.847 7.6 7.6 0 00-5.557-2.404c-4.915 0-8.526 4.586-7.416 9.346-6.325-.317-11.934-3.347-15.69-7.953C2.01 9.869 2.97 14.345 6.358 16.612a7.58 7.58 0 01-3.446-.953c-.084 3.527 2.444 6.826 6.105 7.56a7.63 7.63 0 01-3.438.13 7.618 7.618 0 007.112 5.286A15.306 15.306 0 011.42 31.79a21.55 21.55 0 0011.67 3.42c14.134 0 22.12-11.937 21.637-22.643a15.499 15.499 0 003.799-3.941z"
              ></path>
            </g></svg
        ></a>
      </div>
    </footer>
  </div>
</template>

<script>
import Mint from "./Mint.vue";

export default {
  name: "CouplePunk",
  props: {
    msg: String,
  },
  components: {
    Mint,
  },
  created() {
    let arr = [];
    for (let i = 1; i <= 15; i++) {
      arr.push({
        bg: require("../assets/" + i + ".jpg"),
        shape: "shape" + (i % 3),
      });
    }
    this.items = arr;
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    shuffle() {
      let a = this.items;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      this.items = a;
    },
  },
};
</script>

<style scoped>
.shuffle-group {
}
.shuffle-group .img {
  background-size: cover;
  background-position: center;
  width: 250px;
  height: 250px;
  margin: 25px;
}
.shape1 {
  border-radius: 50%;
}
.shape2 {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -o-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
  overflow: hidden;
  -webkit-clip-path: polygon(
    50% 0%,
    100% 25%,
    100% 75%,
    50% 100%,
    0% 75%,
    0% 25%
  );
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  -ms-clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  -moz-clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}
h1 {
  font-family: "8BIT WONDER Nominal";
  font-weight: normal;
  font-size: 3rem;
}

.shuffle-move {
  transition: all 0.8s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease-out;
}

.fade-enter-from {
  transform: translateY(40px);
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  transform: translateX(200px);
  opacity: 0;
}
</style>
